module.exports = __webpack_public_path__ + "static/media/Elf-Unselected.0479a2f3.png";